import { Controller } from "stimulus";

// Renders a short list of identical inputs submitting under one array name, with
// an add button that disappears at the cap. Clearing a value is the input's own
// job — select2 already offers it — and the server drops the blanks, so there is
// no remove control here.
export default class extends Controller {
  static targets = ["row", "template", "addButton"];
  static values = { max: Number };

  connect() {
    this.refresh();
  }

  add() {
    const row = this.templateTarget.content.cloneNode(true);
    this.templateTarget.parentElement.insertBefore(row, this.templateTarget);
    this.refresh();
  }

  refresh() {
    this.addButtonTarget.hidden = this.rowTargets.length >= this.maxValue;
  }
}
